import { useAppDispatch } from '@/store/hooks';
import { toast } from '@/lib/toast';

export function useToastDispatch() {
  const dispatch = useAppDispatch();
  return {
    success: (message: string) => dispatch(toast.success(message)),
    error: (message: string) => dispatch(toast.error(message)),
    info: (message: string) => dispatch(toast.info(message)),
  };
}
